import { type Session } from '@halo/chat-sdk-react';
import { useIsMyMsg } from '@/scripts/hooks';
import { MsgMediaCard, MsgMediaCardContent } from '../msg-media-card';
import type { MsgMediaCallRejectedContentProps } from './msg-media-call-rejected-content';

export interface MsgMediaCallRejectedProps extends MsgMediaCallRejectedContentProps {
  session: Session;
}

export const MsgMediaCallRejected = memo(function MsgMediaCallRejected({
  message,
  session,
}: MsgMediaCallRejectedProps) {
  const { create_uid } = message.payload;
  const { t } = useTranslation();
  const newMessage = useMemo(() => {
    return {
      ...message,
      owner_id: create_uid,
      origin_owner_id: message.owner_id,
    };
  }, [create_uid, message]);

  const isMe = useIsMyMsg(newMessage);

  return (
    <MsgMediaCard message={newMessage} session={session}>
      <MsgMediaCardContent
        message={message}
        session={session}
        title={t('calls.callDeclinedTitle')}
        description={isMe ? t('calls.callDeclined') : t('calls.callDeclinedReceiver')}
      ></MsgMediaCardContent>
    </MsgMediaCard>
  );
});
